import { Card, CardContent, CardHeader } from '@mui/material';
import * as date from 'date-fns';
import { Area, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

// min, max and stddev are not used in the chart
// but they are included in the data for future use
interface ChartCardProps {
  title: string;
  data: [{
  datetime: Date;
  date: string;
  hour: number;
  avg: number;
  pastavg: number;
  age:number;
  stddev:number;
  stddevp5:number;
}]
}

const AGE_INVALID = Number.MAX_SAFE_INTEGER;

// To restore min, max and stddev in the chart, uncomment the lines below
export const ChartCard: React.FC<ChartCardProps> = ({ title, data }) => {  
  const hasData = data.length > 0;
  const shouldShowBands = hasData && data.every((d) => (d.age ?? 0) !== AGE_INVALID);
  const avgStroke = shouldShowBands ? '#E53935' : '#00A1F2';
  return (
    <Card variant='outlined' sx={{ height: '375px' }}>
      <CardHeader title={title} />
      <CardContent sx={{ height: '85%' }}>
        {!hasData && (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            No data available
          </div>
        )}
        {hasData && (
          <ResponsiveContainer>
            <ComposedChart
              data={data}
              margin={{
                top: 5,
                right: 40,
                left: 0,
                bottom: 5,
              }}
            >
              <CartesianGrid stroke="#eee" strokeDasharray="3 3" />
              <XAxis dataKey="datetime" tick={{ dy: 5 }} tickFormatter={(v, i) => date.format(v, 'yyyy-MM-dd HH:mm')} />
              <YAxis />
              <Tooltip labelFormatter={(l, p) => date.format(l, 'yyyy-MM-dd HH:mm')} />
              <Legend />
              <Line type="monotone" dataKey="avg" stroke={avgStroke} dot={false} />
              {shouldShowBands && (
                <>
                <Line type="monotone" dataKey="pastavg" stroke='#0f0e0eff' dot={false} />
                <Area type="monotone" dataKey="stddev" fillOpacity={0.3} fill="#8262e0ff" stroke="none" />
                <Area type="monotone" dataKey="stddevp5" fillOpacity={0.5} fill="#4857dcff" stroke="none" />
                </>
              )}
              {/* <Area type="monotone" dataKey="stddev" fillOpacity={0.8} fill="#8884d8" /> 
              <Line type="monotone" dataKey="min" strokeDasharray="3 3" stroke='#56423D' dot={false} />
              <Line type="monotone" dataKey="max" strokeDasharray="3 3" stroke='#BEA6A0' dot={false} /> */}             
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}; 